<div [style.background]="backgroundColor" [style.color]="textColor"
  [ngClass]="{'gap-10': text != ''}"
  class="strong-green bg-light-green flex content-center align-items-center" *ngIf="isValidated"
  [ngStyle]="{'background-color': backgroundColor, 'color': textColor, 'border-radius': '5px', 'padding': text == '' ? '5px 5px 5px 5px' : '5px 20px 5px 20px', 'width': fitContent ? 'fit-content' : 'auto'}">
  <img *ngIf="icon.length > 0" width="15px" [src]="icon" [alt]="'icon'">
  <p class="no-margin">{{text}}</p>
</div>